import { useCallback, useMemo } from 'react'

import debounce from 'lodash.debounce'
import { AnyToVoidFunction } from './types'
export default function useDebouncedCallback<T extends AnyToVoidFunction>(
  fn: T,
  deps: any[],
  ms: number,
  noFirst = false,
  noLast = false,
) {
  // eslint-disable-next-line react-hooks-static-deps/exhaustive-deps
  const fnMemo = useCallback(fn, deps)

  return useMemo(() => {
    return debounce(fnMemo, ms, {
      trailing: !noLast,
      leading: !noFirst,
    })
  }, [fnMemo, ms, noFirst, noLast])
}
